import React from 'react';
import { withMultiScreenController } from '../hooks/useMultiScreenController';
import { withMultiScreenServer } from '../hooks/useMultiScreenServer';

export type ControllerProps = React.PropsWithChildren<{}>;

export function Controller(props: ControllerProps) {
    const { children } = props;

    return (
        withMultiScreenController(
            withMultiScreenServer(
                <React.Fragment>{children}</React.Fragment>
            )
        )
    );
}
